export const info = {
  'seo.title': 'Разбор анализов — Нутрициологическая консультация | София и Елена',
  'seo.description': 'Детальный разбор ваших анализов, индивидуальный подбор питания и рекомендации по образу жизни от экспертов-нутрициологов Софии и Елены.',
  'seo.keywords': 'разбор анализов, консультация нутрициолога, индивидуальное питание, рекомендации по здоровью',

  'hero.title': 'Разбор анализов',
  'hero.description': 'Детальный разбор ваших анализов с индивидуальными рекомендациями по питанию и персональным планом действий.',

  'section1.title': 'Что входит в услугу:',
  'section1.paragraph1': 'Мы проводим тщательный разбор всех ваших лабораторных анализов и показателей здоровья, выявляя дефициты, дисбалансы и области, требующие внимания.',
  'section1.paragraph2': 'На основе результатов мы создаем персональный план питания, разработанный специально под потребности вашего организма и цели здоровья.',

  'section2.title': 'Как это работает:',
  'section2.item1': 'Вы отправляете свои анализы',
  'section2.item2': 'Мы проводим детальный разбор',
  'section2.item3': 'Мы встречаемся на консультацию',
  'section2.item4': 'Вы получаете персональный план питания',

  'section3.title': 'Почему выбирают нас:',
  'section3.paragraph1': 'Два эксперта одновременно изучают ваши анализы, что дает комплексный взгляд, охватывающий как нутрициологические, так и косметологические аспекты вашего здоровья.',
  'section3.paragraph2': 'Наш подход — не временные решения. Мы помогаем вам понять свой организм, чтобы вы могли принимать осознанные решения о своем здоровье на всю жизнь.',

  'cta.title': 'Готовы начать путь к здоровью?',
  'cta.description': 'Запишитесь на консультацию и получите персональный план питания на основе ваших анализов.',
  'cta.button': 'Выбрать пакет',
  'cta.buttonAria': 'Выбрать пакет',
};